import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);

// SERVICE WORKER KAYDI (Döngüye sokmayan versiyon)
// Service Worker yalnizca yayin (production) derlemesinde kaydediliyor.
// Gelistirme sunucusunda kayitli oldugunda, onbellekten eski paketi servis edip
// yapilan degisikliklerin ekranda hic gorunmemesine yol aciyordu.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("✅ SW Kaydedildi:", registration.scope);
      })
      .catch((err) => {
        console.error("❌ SW Kayıt Hatası:", err);
      });
  });
}

reportWebVitals();
